(function () {
  "use strict";

  /**
   * Cache DOM elements
   */

  var radiusElem = document.querySelector("[data-silo-radius]");
  var heightElem = document.querySelector("[data-silo-height]");
  var coneElem = document.querySelector("[data-silo-cone-height]");
  var siloTypeElem = document.querySelector("[data-silo-type]");
  var siloEmptyingElem = document.querySelector("[data-silo-emptying]");
  var unitRadius = document.querySelector("[data-silo-radius-unit]");
  var coneWrapperElem = document.querySelector("[data-silo-cone]");
  var resetElem = document.querySelector("[data-silo-reset]");
  var form = document.querySelector(".silo__form");

  // Early return if ".silo__form" not found
  if (!form) {
    return;
  }

  /**
   * Methods
   */

  // Calculate radius based on user input
  function calcRadius(input, unit) {
    // If unit selected is diamter
    if (unit.value == "diameter") {
      var diameter = input / 2;
      return diameter;
    }
    // If unit selected is circumference
    if (unit.value == "circumference") {
      var circumference = input / (Math.PI * 2);
      return circumference;
    }
  }

  // Calculate volume of barrel
  function calcBarrelVolume(radius, input) {
    return Math.PI * Math.pow(radius, 2) * input;
  }

  // Calculate volume of bottom cone
  function calcBottomConeVolume(radius, input) {
    return (Math.PI * Math.pow(radius, 2) * input) / 3;
  }

  // Calculate volume of top cone
  function calcTopConeVolume(radius, emptying) {
    return Math.PI * Math.pow(radius, 3) * 2 * 0.1 * emptying;
  }

  // Get silo model type
  function getSiloModel(input, model) {
    if (input.checked) {
      // Silo is on-ground model
      var model = 0;
      return model;
    } else {
      // Silo has bottom cone
      var model = model;
      return model;
    }
  }

  // Silo emptying - material is coned down
  function getEmptying(input, value) {
    if (input.checked) {
      // Silo is emptying
      var value = -1;
      return value;
    } else {
      // Silo not emptying
      var value = 1;
      return value;
    }
  }

  // Toggle silo model input field
  function toggleSiloModel() {
    var bottomConeElem = document.querySelector(".bottom-cone");

    if (siloTypeElem.checked) {
      // Silo is on-ground model
      coneWrapperElem.classList.add("is-hidden");
      bottomConeElem.classList.add("is-hidden");
    } else {
      // Silo has bottom cone
      coneWrapperElem.classList.remove("is-hidden");
      bottomConeElem.classList.remove("is-hidden");
    }
  }

  // Toggle silo emptying transition
  function toggleSiloEmptying() {
    var grainElem = document.querySelector(".grain");
    var grainEmptyingElem = document.querySelector(".grain-emptying");

    if (siloEmptyingElem.checked) {
      // Silo is emptying
      grainElem.classList.add("is-hidden");
      grainEmptyingElem.classList.add("is-active");
    } else {
      // Silo not emptying
      grainElem.classList.remove("is-hidden");
      grainEmptyingElem.classList.remove("is-active");
    }
  }

  // Calculate material volume
  function calcMaterialVolume(total) {
    // Add total volumes for different materials.
    var results = Array.from(document.querySelectorAll("[data-result]"));
    var resultsString = " tonnes";
    results.forEach(function (el) {
      switch (el.dataset.result) {
        case "wheat":
          el.textContent = Number(Math.floor(total * 0.78 * 100) / 100);
          el.textContent += resultsString;
          break;
        case "barley":
          el.textContent = Number(Math.floor(total * 0.63 * 100) / 100);
          el.textContent += resultsString;
          break;
        case "triticale":
          el.textContent = Number(Math.floor(total * 0.65 * 100) / 100);
          el.textContent += resultsString;
          break;
        case "oats":
          el.textContent = Number(Math.floor(total * 0.51 * 100) / 100);
          el.textContent += resultsString;
          break;
        case "lupins":
          el.textContent = Number(Math.floor(total * 0.77 * 100) / 100);
          el.textContent += resultsString;
          break;
        case "canola":
          el.textContent = Number(Math.floor(total * 0.62 * 100) / 100);
          el.textContent += resultsString;
          break;
        case "corn":
          el.textContent = Number(Math.floor(total * 0.72 * 100) / 100);
          el.textContent += resultsString;
          break;
        case "sorghum":
          el.textContent = Number(Math.floor(total * 0.72 * 100) / 100);
          el.textContent += resultsString;
          break;
        case "polypropylene":
          el.textContent = Number(Math.floor(total * 0.56 * 100) / 100);
          el.textContent += resultsString;
          break;
        case "total-volume":
          el.textContent = Number(Math.floor(total * 100) / 100);
          break;
        default:
          break;
      }
    });
  }

  // Toggle animation
  function tableTransition() {
    var tableRows = Array.from(document.querySelectorAll(".silo__result"));
    tableRows.forEach(function (el) {
      if (form.classList.contains("is-submitted")) {
        el.classList.add("is-active");
      } else {
        el.classList.toggle("is-active");
      }
    });
  }

  // Calculate silo volume
  function calcSiloVolume() {
    var radius = calcRadius(radiusElem.value, unitRadius);
    var barrelVolume = calcBarrelVolume(radius, heightElem.value);
    var siloEmptying = getEmptying(siloEmptyingElem, topConeVolume);
    var topConeVolume = calcTopConeVolume(radius, siloEmptying);
    var bottomConeVolume = calcBottomConeVolume(radius, coneElem.value);
    var siloModel = getSiloModel(siloTypeElem, bottomConeVolume);
    var total = barrelVolume + topConeVolume + siloModel - siloEmptying;
    tableTransition();
    calcMaterialVolume(total);
  }

  /**
   * Inits & Event Listeners
   */

  // Listen for submit events
  form.addEventListener("submit", function (event) {
    // Prevent the form from being sent
    event.preventDefault();

    // Calculate silo volume
    calcSiloVolume();

    // Add class needed for animation
    form.classList.add("is-submitted");
  });

  // Listen for clicks on checkbox
  siloTypeElem.addEventListener("click", function () {
    // Toggle silo model input field
    toggleSiloModel();
  });

  // Listen for clicks on checkbox
  siloEmptyingElem.addEventListener("click", function () {
    // Toggle silo empyting transition
    toggleSiloEmptying();
  });

  // Listen for clicks on reset button
  resetElem.addEventListener("click", function (event) {
    // Prevent the form from being sent
    event.preventDefault();

    // Reset form
    form.reset();

    // Add class needed for animation
    form.classList.remove("is-submitted");

    // Toggle animation
    tableTransition();

    // Toggle silo model input field
    toggleSiloModel();
  });

  console.log("working");
})();
